import React from "react";
import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/company";
import { cn } from "@/lib/utils";

// Click-to-call company number: native dialer on phones, plain link on desktop.
export function PhoneLink({ className, testid = "company-phone", size = "sm" }) {
  return (
    <a href={COMPANY.phoneTel} data-testid={testid} aria-label={`Call AuraMax HQ at ${COMPANY.phoneDisplay}`} className={cn("inline-flex items-center gap-1.5 font-semibold text-white hover:underline", size === "lg" ? "text-lg" : "text-sm", className)}>
      <Phone className={size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5"} /> {COMPANY.phoneDisplay}
    </a>
  );
}
